import React from "react";

import MenuContext, { IContext } from "./context";

const useMenu = (): IContext => {
  const context = React.useContext(MenuContext);

  if (!context) {
    throw new Error("useMenu must be used within a MenuProvider");
  }

  return context;
};

export default useMenu;
